import React from 'react';
import Drawer, { FooterSpacer } from '../Drawer';
import Button from '../Button';
import Field from '../Field';
import { practiceCanSave } from '../../domain/practice';
import s from './drawers.module.css';
import { DateInput } from '../RegionInputs';

export default function PracticeTimeDrawer({ open, form, onChange, onClose, onSave }) {
  return (
    <Drawer
      open={open}
      onClose={onClose}
      title="Add Practice Time"
      width={520}
      footer={(
        <>
          <Button variant="secondary" onClick={onClose}>Cancel</Button>
          <FooterSpacer />
          <Button disabled={!practiceCanSave(form.minutes, form.practicedOn)} onClick={onSave}>Save</Button>
        </>
      )}
    >
      <div className={s.topPair}>
        <Field label="Date">
          <DateInput className={s.input} value={form.practicedOn}
                 onChange={(e) => onChange({ practicedOn: e.target.value })} />
        </Field>
        <Field label="Minutes">
          <input type="number" min="1" step="5" className={s.input} value={form.minutes}
                 onChange={(e) => onChange({ minutes: e.target.value })} />
        </Field>
      </div>
      <div className={s.section}>
        <Field label="Note" hint="Optional">
          <textarea rows={3} className={s.input} value={form.note}
                    onChange={(e) => onChange({ note: e.target.value })} />
        </Field>
      </div>
    </Drawer>
  );
}
